module.exports = __webpack_public_path__ + "img/신용산 맛집.33053554.png";